module.exports = (__webpack_require__(0))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-react.js from dll-reference rlink_core
// module id = 1
// module chunks = 0